import { navigate } from 'hookrouter';
import { useCallback, useState } from 'react';

import { StepUpRequiredError } from '../api/errors';
import { IDENTITY_WIDGET_PATHS } from '../utils/constants';

/**
 * Detects the ARO ID.me step-up challenge thrown by the guided-sign-in, guest/activate,
 * and guest/forgotPassword endpoints, and manages the Verify Identity modal that should
 * be shown for it. Consumers still own their own error state for every other failure.
 */
export const useStepUpChallenge = () => {
  const [stepupContextId, setStepupContextId] = useState<string | null>(null);

  const handleStepUpChallenge = useCallback((error: unknown): boolean => {
    if (error instanceof StepUpRequiredError) {
      setStepupContextId(error.stepupContextId);
      return true;
    }
    return false;
  }, []);

  const closeStepUpModal = useCallback(() => setStepupContextId(null), []);

  const useDifferentAccount = useCallback(() => {
    setStepupContextId(null);
    navigate(IDENTITY_WIDGET_PATHS.SignInOrJoin, true);
  }, []);

  return {
    stepupContextId,
    isStepUpModalOpen: stepupContextId !== null,
    handleStepUpChallenge,
    closeStepUpModal,
    useDifferentAccount,
  };
};
